import Utils from '../../services/utils';

const ALL = 'all';
const CASH = 'CASH';
const TRANSFER = 'TRANSFER';
const DEBIT = 'DEBIT';
const CREDIT = 'CREDIT';

export const paymentsTypesValueLabelList = [
  /* { value: ALL, label: 'Todos' }, */
  { value: CASH, label: 'Efectivo' },
  { value: TRANSFER, label: 'Transferencia' },
  { value: DEBIT, label: 'Tarjeta' },
  { value: CREDIT, label: 'Crédito' }
];

export const paymentsTypesLabelsObject = Utils.valueLabelListToLabelsObject(paymentsTypesValueLabelList);

const paymentTypes = {
  ALL,
  CASH,
  TRANSFER,
  DEBIT,
  CREDIT
};

export default paymentTypes;
